import React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { IoMdClose } from "react-icons/io";
import "./answerAndReplyNotificationModal.css";
import activityStyle from "src/Assets/css/Activity/activity.module.css";
import feedstyles from "src/Assets/css/home/feedpost.module.css";
import AvatarBadge from "src/Components/AvatarBadge";
import { ProfileHoverCard } from "src/pages/HomePage/components/ProfileHoverCard";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  maxWidth: 600,
  bgcolor: "#E5E4E2",
  border: "none",
  borderRadius: 5,
  px: 4, // padding left + right
  py: 2, // padding top + bottom
};

export default function BlockedAndWarningNotificationModal(props) {
  const {
    blockedAndWarningNotificationData,
    isModelOpen,
    handleCloseBlockedAndWarningModal,
  } = props;

  const profileImagePath = process.env.REACT_APP_SKOPIC_IMAGE;

  return (
    <div>
      <Modal
        open={isModelOpen}
        onClose={() => handleCloseBlockedAndWarningModal()}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="ans-and-reply--modal-header">
            <button
              type="button"
              onClick={() => {
                handleCloseBlockedAndWarningModal();
              }}
            >
              <IoMdClose className="block-modal-close-icon" />
            </button>
          </div>
          <div
            className="ans-reply-post-card"
            key={blockedAndWarningNotificationData?.messageId}
          >
            <div className="profile-info">
              <div
                className={activityStyle.activityPostImageDropdownMainContainer}
              >
                <div
                  className={activityStyle.activityPostImageProfileContainer}
                >
                  <div className={activityStyle.profileimg}>
                    <div className={feedstyles.avatarContainer}>
                      <AvatarBadge
                        src={`${profileImagePath}${blockedAndWarningNotificationData?.mainuserdata?.uimage}`}
                        alt={
                          blockedAndWarningNotificationData?.mainuserdata
                            ?.displayName
                        }
                        isPrimaryModerator={
                          String(blockedAndWarningNotificationData?.mainuserdata?.isPM) === "1" &&
                          String(blockedAndWarningNotificationData?.mainuserdata?.isModerator) === "1"
                        }
                        isModerator={
                          String(blockedAndWarningNotificationData?.mainuserdata?.isModerator) === "1" &&
                          String(blockedAndWarningNotificationData?.mainuserdata?.isPM) === "0"
                        }
                      />
                      <ProfileHoverCard
                        result={blockedAndWarningNotificationData}
                        filterType={props?.filterType}
                      />
                    </div>
                  </div>
                  <div
                    style={{ flex: 1 }}
                    className={activityStyle.profilename}
                  >
                    <p>
                      {
                        blockedAndWarningNotificationData?.mainuserdata
                          ?.displayName
                      }
                    </p>
                    <div className={activityStyle.timeLocationContainer}>
                      <span
                        className={
                          blockedAndWarningNotificationData?.loc_name
                            ? activityStyle.tenantAndTimeName
                            : activityStyle.tenantAndTimeNameWithoutLocation
                        }
                      >
                        {blockedAndWarningNotificationData?.Message_Time} in{" "}
                        {blockedAndWarningNotificationData?.tenantName}{" "}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style={{ marginTop: "10px" }}>
              {blockedAndWarningNotificationData?.keyword === "BL" && (
                <p className={activityStyle.blockOrwarnMessage}>
                  Your community Moderator has blocked your access in{" "}
                  {blockedAndWarningNotificationData?.tenantName}
                </p>
              )}
              {blockedAndWarningNotificationData?.keyword === "WRN" && (
                <p className={activityStyle.blockOrwarnMessage}>
                  Your community Moderator in{" "}
                  {blockedAndWarningNotificationData?.tenantName} has sent a
                  warning.
                </p>
              )}
              {blockedAndWarningNotificationData?.reason && (
                <p className={activityStyle.blockOrwarnMessageReason}>
                  Reason:{" "}
                  <span>{blockedAndWarningNotificationData?.reason}</span>
                </p>
              )}
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
}
